/***************** Wishlist Code start here *****************/

// Helper: jQuery-style $ selector
const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);

// Helper: delegate event listener (replaces jQuery(document).on)
function onDelegate(eventType, selector, handler) {
  document.addEventListener(eventType, function (e) {
    const target = e.target.closest(selector);
    if (target) handler.call(target, e);
  });
}

// Helper: get cookie
function getCookieData(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? JSON.parse(match[2]) : [];
}

// Helper: get/set wishlist from localStorage
function getWishlist() {
  return JSON.parse(localStorage.getItem("wishlist")) || [];
}
function saveWishlist(data) {
  localStorage.setItem("wishlist", JSON.stringify(data));
}

// SVG icons
const HEART_FILLED = `<svg class="heart-filled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="12" fill="#EC3C3C"/>
<path d="M9 7C7.3434 7 6 8.36686 6 10.0532C6 11.4146 6.525 14.6454 11.6928 17.9115C11.7854 17.9694 11.8916 18 12 18C12.1084 18 12.2146 17.9694 12.3072 17.9115C17.475 14.6454 18 11.4146 18 10.0532C18 8.36686 16.6566 7 15 7C13.3434 7 12 8.85045 12 8.85045C12 8.85045 10.6566 7 9 7Z" fill="white"/>
</svg>`;

const HEART_OUTLINE = `<svg class="heart-outline" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M5.93415 18.5444L15.3152 27.357C15.6397 27.6618 15.8019 27.8141 15.9999 27.8141C16.1979 27.8141 16.3602 27.6618 16.6846 27.357L26.0657 18.5444C28.6739 16.0943 28.9907 12.0623 26.797 9.23492L26.3845 8.70328C23.7603 5.32094 18.4928 5.88818 16.6488 9.7517C16.3883 10.2974 15.6115 10.2974 15.351 9.7517C13.5071 5.88818 8.23955 5.32094 5.61531 8.70328L5.20284 9.23492C3.00918 12.0623 3.32592 16.0943 5.93415 18.5444Z" stroke="#919191" stroke-opacity="0.77" stroke-width="1.4"/>
</svg>`;

// Update wishlist count in header
function updateWishlistCount(count) {
  const countEl = document.querySelector(".wishlist-count");
  if (countEl) {
    countEl.textContent = count;
    countEl.style.display = count === 0 ? "none" : "";
  }
}

// Wishlist toggle: add or remove product
function toggleWishlist(btn, flag = "") {
  let productUrl = btn.getAttribute("data-url") || "";
  if (productUrl.includes("?")) productUrl = productUrl.split("?")[0];

  const pdpData = {
    product_title: btn.getAttribute("data-ptitle"),
    product_image: btn.getAttribute("data-pimage"),
    product_price: btn.getAttribute("data-pprice"),
    product_url: productUrl,
    variant_id: btn.getAttribute("data-variantid"),
    product_id: btn.getAttribute("data-pid"),
    price_normal: btn.getAttribute("data-pricenormal") || 0,
    product_vendor: btn.getAttribute("data-vendor"),
    compare_normal: btn.getAttribute("data-cppricenormal") || 0,
    available: btn.getAttribute("data-available") || "true",
  };

  let wishlistData = getWishlist();
  const alreadyInWishlist = wishlistData.some((item) => item.variant_id === pdpData.variant_id);
  const firstBtn = $(".wishlist_button");

  if (!alreadyInWishlist) {
    wishlistData.push(pdpData);
    saveWishlist(wishlistData);
    if (flag === "" && firstBtn) firstBtn.innerHTML = HEART_FILLED;
  } else {
    wishlistData = wishlistData.filter((item) => item.variant_id !== pdpData.variant_id);
    saveWishlist(wishlistData);
    if (flag === "" && firstBtn) firstBtn.innerHTML = HEART_OUTLINE;
  }

  addedWishListFill();
  updateWishlistCount(wishlistData.length);
  if (flag !== "") displayWishlist();
}

// Remove product from wishlist by variantId
function removeFromWishlist(variantId) {
  const wishlistData = getWishlist().filter((item) => item.variant_id !== variantId);
  saveWishlist(wishlistData);
  displayWishlist();
}

// Display all wishlist items
function displayWishlist() {
  const wishlistData = getWishlist();
  const wishlistBlock = $(".js-wishlistBlock");

  updateWishlistCount(wishlistData.length);

  if (!wishlistBlock) return;

  if (wishlistData.length === 0) {
    wishlistBlock.innerHTML = `<div class="wishlist_empty_heading">Wishlist is empty</div>`;
    wishlistBlock.classList.add("is-empty-wishlist");
    return;
  }

  updateWishlistCount(wishlistData.length);

  const wishlistHtml = wishlistData.map((item) => {
  const isSoldOut = item.available === "false";
  return `
    <li class="grid__item">
      <div class="wishlist-product__list card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
          <div class="card__inner color-scheme-3 gradient ratio" style="--ratio-percent: 125.0%;">
            <div class="card__media">

                <button class="product-wish-btn wishlist_button remove_wishlist_product"
                  data-url="${item.product_url}"
                  data-pimage="${item.product_image}"
                  data-pprice="${item.product_price}"
                  data-pricenormal="${item.price_normal}"
                  data-cppricenormal="${item.compare_normal}"
                  data-ptitle="${item.product_title}"
                  data-pid="${item.product_id}"
                  data-vendor="${item.product_vendor}"
                  data-variantid="${item.variant_id}">
                  ${HEART_FILLED}
                </button>
              <div class="media media--transparent media--hover-effect">
                <a href="${item.product_url}">
                  <img src="${item.product_image}" alt="${item.product_title}">
                </a>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
                <div class="card__information_top">
                    <h5 class="card__heading">
                        <a href="${item.product_url}" class="full-unstyled-link">${item.product_title}</a>
                    </h5>
                    <div class="card-price_block">
                        <div class="price">
                            <span class="price-item price-item--regular">${item.product_price}</span>
                        </div>
                    </div>
                </div>
                <div class="buy-buttons-block">
                    <product-form-component data-section-id="template--21629918445825__product_slider_hWwdgE" data-product-id="${item.product_id}" data-product-url="${item.product_url}" on:submit="/handleSubmit">
                        <div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>
                        <form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" data-type="add-to-cart-form">
                            <input type="hidden" name="form_type" value="product">
                            <input type="hidden" name="utf8" value="✓">
                            <input type="hidden" name="id" ref="variantId" value="${item.variant_id}">
                            <div class="product-form-buttons spacing-style" style="--padding-block-start: 8px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px;" ref="productFormButtons">
                                <span class="product-form-text__error hidden" ref="addToCartTextError">
                                    <span class="svg-wrapper">
                                        <svg class="icon icon-error" viewBox="0 0 13 13">
                                            <circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="var(--icon-stroke-width)"></circle>
                                            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle>
                                            <path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path>
                                            <path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path>
                                        </svg>
                                    </span>
                                </span>

                                <span style="--add-to-cart-font-case: ;">
                                    <add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="${item.product_image}" data-add-to-cart-animation="true">
                                        
                                        <button type="submit" 
                                            data-vid="${item.variant_id}" 
                                            name="add" ref="addToCartButton" on:click="/handleClick" 
                                            class="button add-to-cart-button button-secondary ${isSoldOut ? 'sold-out-btn' : ''}" ${isSoldOut ? 'disabled="disabled"' : ''}>
                                            <span class="add-to-cart-text">
                                                <span aria-hidden="true" class="svg-wrapper add-to-cart-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"></path></svg>
                                                </span>
                                                <span class="add-to-cart-text__content">
                                                    <span>
                                                        <span>
                                                            ${isSoldOut ? 'Sold Out' : 'Add to cart'}
                                                        </span>
                                                    </span>
                                                </span>
                                            </span>
                                                
                                            <span class="add-to-cart__added">
                                                <span class="svg-wrapper add-to-cart__added-icon">
                                                    <svg aria-hidden="true" class="checkmark-burst" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g class="check">
                                                            <circle class="ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                                                            <path class="tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        </g>
                                                        <g class="burst">
                                                            <g style="--index: 0;">
                                                            <line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line>
                                                            </g>
                                                            <g style="--index: 1;">
                                                            <line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line>
                                                            </g>
                                                            <g style="--index: 2;">
                                                            <line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line>
                                                            </g>
                                                            <g style="--index: 3;">
                                                            <line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line>
                                                            </g>
                                                            <g style="--index: 4;">
                                                            <line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line>
                                                            </g>
                                                            <g style="--index: 5;">
                                                            <line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line>
                                                            </g>
                                                            <g style="--index: 6;">
                                                            <line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line>
                                                            </g>
                                                            <g style="--index: 7;">
                                                            <line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </span>
                                            </span>
                                        </button>
                                    </add-to-cart-component>
                                </span>

                            </div>
                            <input type="hidden" name="product-id" value="${item.product_id}">
                            <input type="hidden" name="section-id" value="template--21629918445825__product_slider_hWwdgE">
                        </form>
                    </product-form-component>
                </div>
            </div>
          </div>
        </div>
      </div>
    </li>
    `;
  }).join("");

  wishlistBlock.innerHTML = `<ul class="resource-list--grid product-grid contains-card contains-card--product" role="list">${wishlistHtml}</ul>`;
}

// Fill heart icons based on wishlist state
function addedWishListFill() {
  const wishlistData = getWishlist();
  const allBtns = $$(".wishlist_button");
  if (!allBtns.length) return;

  const urlSet = new Set(wishlistData.map((p) => p.product_url).filter(Boolean));
  const isCollection = document.body.classList.contains("collection");

  allBtns.forEach((btn) => {
    const url = btn.getAttribute("data-url");
    btn.innerHTML = urlSet.has(url) ? HEART_FILLED : HEART_OUTLINE;
  });
}

// Event: click on wishlist button
onDelegate("click", ".wishlist_button", function () {
  const flag = this.classList.contains("remove_wishlist_product") ? 1 : "";
  toggleWishlist(this, flag);
});

// Event: move product from trial cart to wishlist
onDelegate("click", ".trial-cart-add-wishlist", function () {
  const productData = getCookieData("try_cookie_product");
  if (!productData || productData.length === 0) return;

  const removeVariantId = this.getAttribute("remove-variantid");
  const productId = this.getAttribute("remove-pid");

  const idx = productData.findIndex((p) => p.product_id == productId);
  if (idx !== -1) {
    const wishlistData = getWishlist();
    wishlistData.push(productData[idx]);
    saveWishlist(wishlistData);
    productData.splice(idx, 1);
  }

  if (typeof removeArrayElement === "function") removeArrayElement(tyrHomeProductArr, "variant_id", removeVariantId);

  setCookie("try_cookie_product", "", -1);
  setCookie("try_cookie_product", JSON.stringify(productData), 1);

  if (typeof trycartItemList === "function") trycartItemList();

  const trialHead = document.querySelector(".custom-head-trial");
  if (trialHead) trialHead.textContent = "HOME TRIAL CART (" + productData.length + ")";

  if (productData.length === 0) {
    const footer = document.querySelector(".main-drawer_footer");
    if (footer) footer.style.display = "none";
    if (!document.querySelector("#total_cart")?.value > 0) {
      const head = document.querySelector(".header-and-progress");
      const cartWrap = document.querySelector(".cart-home-wrapper");
      if (head) head.style.display = "none";
      if (cartWrap) cartWrap.style.display = "none";
    }
  }

  if (typeof notify === "function") notify("Design Added to favourite", "error");

  const trialBtn = document.querySelector(".trialbtn_" + productId);
  const addedBtn = document.querySelector(".addedbtn_" + productId);
  if (trialBtn) trialBtn.style.display = "none";
  if (addedBtn) addedBtn.style.display = "";

  displayWishlist();
});

// Event: move from cart to wishlist
onDelegate("click", ".cart-add-move-wishlist", function () {
  const variantId = this.getAttribute("data-variantid");
  toggleWishlist(this, 1);
  const removeBtn = document.querySelector(`#CartDrawer-CartItems [data-remove="${variantId}"]`);
  if (removeBtn) removeBtn.click();
});

// On DOM ready
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(addedWishListFill, 1000);
  displayWishlist();
  updateWishlistCount(getWishlist().length);
});

// Scroll: update wishlist icons when recommendations load
let recommendTriggered = false;
window.addEventListener("scroll", function () {
  if (!recommendTriggered) {
    const recSection = document.querySelector(".content-for-layout .related-products.product-recommendations--loaded");
    if (recSection) {
      addedWishListFill();
      recommendTriggered = true;
    }
  }
});

// Remove All Button click event
function removeAllWishlist() {
  localStorage.removeItem("wishlist");
  updateWishlistCount(0);
  addedWishListFill();
  displayWishlist();
}
onDelegate("click", ".wishlist_remove_all", function () {
  removeAllWishlist();
});

/***************** Wishlist Code end here *****************/